import { render, staticRenderFns } from "./OrderAlphabeticalAscending.vue?vue&type=template&id=600f5b32&"
import script from "./OrderAlphabeticalAscending.vue?vue&type=script&lang=js&"
export * from "./OrderAlphabeticalAscending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports